import { AlertResponse } from '@finxone-platform/shared/sys-config-types';

export class UpdateProjectAlertsSubject {
  static readonly type = '[Project] UpdateProjectAlertsSubject';
  constructor(public alertData: AlertResponse) {}
}
